import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext.js';
import { db } from '../../firebase/firebase.js';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import './SubmitAbstract.css';

const CongratulationsPage = () => {
  const { currentUser } = useAuth();
  const [abstracts, setAbstracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSubmissionDetails = async () => {
      if (currentUser) {
        try {
          const userDoc = await getDoc(doc(db, 'Users', currentUser.uid));
          if (userDoc.exists()) {
            const abstractFiles = userDoc.data()?.abstracts || [];
            console.log('Fetched abstracts:', abstractFiles); // Log the data for debugging
            setAbstracts(abstractFiles); // Assuming abstract is an array of submissions
          } else {
            console.log('No user data found');
          }
        } catch (error) {
          console.error('Error fetching submission details:', error);
        }
      }
      setLoading(false);
    };

    fetchSubmissionDetails();
  }, [currentUser]);


  if (loading) return <p>Loading...</p>;

  return (
<div className="view-submission-page">
  <div className="view-submission-container">
    <p className="submission-header">🎉 Congratulations! 🎉</p>

    <p className="submission-message">
    <strong>Your abstract has been officially accepted for presentation at our conference. </strong>
      To confirm your participation, please complete the attendance confirmation form linked below no later than 
      <strong> April 15 at 11:59 PM</strong>. Your timely response is essential to ensure your inclusion in the final program. 
      If you need more time to apply for funding before you can make the decision, please <a href="mailto:bruinlinguists@gmail.com"> 
      email us</a> by the confirmation date above.
    </p>
    <a href="https://forms.gle/zYB9CT2eLae2WtCWA" target="_blank" rel="noopener noreferrer">
      <button className="blue-button">Confirm Your Attendance</button>
    </a>

    {/* Separator */}
    <hr className="divider" />

    {/* Presentation Details */}
    <h3 className="view-submissions-header">Presentation Format & Expectations</h3>
    <p className="submission-message">
      Each presenter will have <strong>15 minutes</strong> to deliver their presentation, followed by a <strong>5-minute Q&A session</strong>. You may choose to participate in a 
      <strong> presentation session, a poster session, or both</strong>.  Those that cannot attend in person to present a live oral presentation may choose to schedule virtual 
      presentation and attend the conference through Zoom. If you opt for a webinar presentation, please let us know as soon as possible. 
    </p>
    <p className="submission-message">
      If you are presenting, please submit your <strong>final presentation materials</strong> (e.g. slides, handouts) to 
      <a href="mailto:bruinlinguists@gmail.com"> bruinlinguists@gmail.com</a> by <strong>May 10 at 11:59 PM</strong>.
      Presenters may bring a flash drive with their presentation materials to the conference, but all presentation materials must be submitted ahead of time.
      We encourage you to review prior years’ presentations for reference: 
      <a href="https://sites.google.com/view/sculc-2022/presentations?authuser=2" target="_blank" rel="noopener noreferrer"> View Past Presentations</a>.
    </p>

    <p className="submission-message">
      We sincerely appreciate your contribution and look forward to your participation. Should you have any questions, please do not hesitate to reach out.
    </p>

    {/* Separator */}
    <hr className="divider" />

    {/* Submissions Section */}
    <h3 className="view-submissions-header">View Your Submissions</h3>
    {abstracts.length > 0 ? (
      <div className="submission-list">
        {abstracts.map((submission, index) => (
          <button
            key={index}
            onClick={() => window.open(submission.url, "_blank", "noopener,noreferrer")}
            className="hyperlink-button"
          >
            {submission.name || `View Submission ${index + 1}`}
          </button>
        ))}
      </div>
    ) : (
      <p className="submission-message">No submissions found. Please ensure your submission was successful.</p>
    )}

  </div>
</div>

  );
};

export default CongratulationsPage;
